export const sectionRamps = {
  sand: [
    // "#FFFDF8",
    // "#FCF9F2",
    // "#FAF6EF",
    // "#F8F4EC",
    // "#F6F1E9",
    // "#F4EEE6",
    // "#F2EBE3",
    // "#F0E8E0",
    // "#EEE5DD",
    // "#ECE2DA",
    // "#EADFD7",
    // "#E8DCD4",
    // "#E6D9D1",
    // "#E4D6CE",
    // "#E2D3CB",
    // "#4A4035",
    "#DFCDB6",
    "#DAC3A8",
    "#D4B99A",
    "#CEAF8C",
    "#C8A57E",
    "#C19B70",
  ],

  rose: [
    "#FFF0F9",
    "#FFEDF8",
    "#FFEAF7",
    "#FFE7F6",
    "#FFE4F5",
    "#FFE1F4",
    "#FFDEF3",
    "#FFDBF2",
    "#FFD8F1",
    "#FFD5F0",
    "#FFD2EF",
    "#FFCFEE",
    "#FFCCED",
    "#FFC9EC",
    "#FFC6EB",
    "#563A46",
  ],

  blue: [
    "#B7E5FF",
    "#B6E3FD",
    "#B5E1FB",
    "#B4DFF9",
    "#B3DDF7",
    "#B2DBF5",
    "#B1D9F3",
    "#B0D7F1",
    "#AFD5EF",
    "#AED3ED",
    "#ADD1EB",
    "#ACCFE9",
    "#ABCDE7",
    "#AACBE5",
    "#A9C9E3",
    "#243746",
  ],
} as const;

export const palettes = {
  sand: {
    navbar: "#DFCDB6", //"#F8F4EC",
    hero: "#DAC3A8", //"#F8F4EC",
    featured: "#D4B99A", //"#F2ECE0",
    story: "#CEAF8C", //"#ECE3D2",
    cta: "#C8A57E", //"#ECE3D2",
    footer: "#C19B70", //"#E4D7C4",
    text: "#2f2a24",
    paper: "#D4B99A", //"#F0E8E0", //'#fffdf9',
    primary: "#7b5d3d",
    secondary: "#b58b55",
    controlBg: "#f3efe8",
    controlBorder: "#cfc3b7",
    controlText: "#6b5a4d",
    controlHoverBg: "#e8dfd4",
    navbarText: "#4A4035",
  },
  rose: {
    navbar: "#FFF0F9",
    hero: "#FFEDF8",
    featured: "#FFEAF7",
    story: "#FFE7F6",
    cta: "#FFE4F5",
    footer: "#FFE1F4",
    text: "#2f2a24",
    paper: "#FFDBF2", //#fffdf9',
    primary: "#7b5d3d",
    secondary: "#b58b55",
    controlBg: "#f3efe8",
    controlBorder: "#cfc3b7",
    controlText: "#6b5a4d",
    controlHoverBg: "#e8dfd4",
    navbarText: "#563A46",
  },

  blue: {
    navbar: "#B7E5FF",
    hero: "#B6E2FC",
    featured: "#B5DFF9",
    story: "#B4DCF6",
    cta: "#B3D9F3",
    footer: "#B2D6F0",
    text: "#2f2a24",
    paper: "#B0D7F1",
    primary: "#7b5d3d",
    secondary: "#b58b55",
    controlBg: "#f3efe8",
    controlBorder: "#cfc3b7",
    controlText: "#6b5a4d",
    controlHoverBg: "#e8dfd4",
    navbarText: "#243746",
  },
} as const;
